/** Store do cache de GETs, isolado num módulo sem imports de propósito.
 *
 *  `cache.ts` (quem lê) importa `client.ts`, e `client.ts` (quem invalida)
 *  precisa mexer no mesmo store — pôr o Map em qualquer um dos dois criaria
 *  ciclo de import entre eles. Aqui o store é folha da árvore de dependências
 *  e os dois lados o importam sem se enxergarem.
 */

interface CacheEntry {
  data: unknown;
  expiresAt: number;
}

export const cacheEntries = new Map<string, CacheEntry>();
export const inFlight = new Map<string, Promise<unknown>>();

/** Geração do cache. Incrementa a cada invalidação pra que um GET que já
 *  estava em voo saiba, ao resolver, que o mundo mudou embaixo dele — ver
 *  `cachedApi`. Limpar os dois Maps não basta: o `.then()` do GET em voo já
 *  está agendado e gravaria o dado pré-mutação com TTL cheio. */
let epoch = 0;

export function currentEpoch(): number {
  return epoch;
}

/** Derruba o cache inteiro. Chamado automaticamente por `client.ts` depois de
 *  qualquer request não-GET — ver o comentário lá pro porquê de ser cego.
 *
 *  `inFlight` também é limpo: mantê-lo faria `cachedApi` reentregar, logo após
 *  a mutação, a promise disparada antes dela. */
export function clearAll(): void {
  cacheEntries.clear();
  inFlight.clear();
  epoch++;
}
